import React, {Component} from 'react';

export default class AnswerButton extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            timeLeft: 0
        }
        this.intervalId = null;
    }

    componentDidMount() {
        this.onClick = this.props.click;
        this.message = this.props.message;
        this.time = this.props.time;

        if(this.intervalId) {
            clearInterval(this.intervalId);
        }

        this.setState({...this.state, timeLeft: this.time});

        this.intervalId = setInterval(()=>{
            const timeLeft = this.state.timeLeft - 1;

            if(timeLeft === 0) {
                clearInterval(this.intervalId);
                this.onClick();
                return;
            }

            this.setState({...this.state, timeLeft: timeLeft});

        }, 1000);
    }

    componentWillUnmount() {
      clearInterval(this.intervalId);
    }

    render() {
        if(!this.intervalId) {
            return null;
        }

        return (
            <button className="button" onClick={this.onClick}>{this.message} ({this.state.timeLeft})</button>
        )
    }
}
